import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overlay-loader',
  templateUrl: './overlay-loader.component.html',
  styleUrls: ['./overlay-loader.component.scss'],
  standalone: false
})
export class OverlayLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
